<script>
import classes from '~~/common/vue/mixins/classes';

// TODO: refactor and rename to `variant`
export const colors = ['primary', 'secondary', 'white', 'dark', 'bare', 'result'];

export default {
  name: 'ELink',
  mixins: [classes],
  props: {
    as: {
      type: String,
      default: 'a',
    },
    // TODO: refactor and rename to `variant`
    color: {
      type: String,
      default: colors[0],
      cssClass: true,
      validator: (value) => colors.includes(value),
    },
  },
  render(create) {
    const attrs = {};
    if (this.as !== 'a') {
      attrs.role = 'button';
    }
    const options = {
      class: this.classes,
      attrs: { ...attrs, ...this.$attrs },
      on: this.$listeners,
    };
    return create(this.as, options, this.$slots.default);
  },
};
</script>

<style lang="scss" scoped>
$colors: (
  "primary": $blue-50,
  "secondary": $gray-40,
  "white": $white,
  "dark": $gray-60,
  "result": $color-link-results-default,
);

.link {
  text-decoration: none;
  transition: color $timing-2s $easing;
  cursor: pointer;

  @each $name, $color in $colors {
    &--color-#{$name} {
      color: $color;

      &:hover,
      &:focus {
        text-decoration: underline;
      }
    }
  }

  &--color-bare {
    color: $gray-40;

    &:hover,
    &:focus {
      color: $gray-60;
    }
  }

  &--color-result {
    &:visited {
      color: $color-link-results-visited;
    }
  }
}
</style>
